export const ARROW_LEFT = 'ArrowLeft';

export const ARROW_RIGHT = 'ArrowRight';
